export enum JustupOffre {
  JUSTUP = "JUSTUP",
  JUSTUP_LITE = "JUSTUP_LITE",
}
